import React, { Component } from "react";
import Axios from 'axios';
import { Modal, Spinner, Table } from "reactstrap";
import moment from 'moment';
import { connect } from "react-redux";
import { add, list } from '../../store/actions';
import TextField from '../../components/Form/TextField';
import DatePicker from '../../components/Form/DatePicker';
import SelectForm from "../../components/Form/SelectForm";
import withFormik from '../../utils/withFormik';
import { getUser } from '../../utils/localstorage';
import { URL_API } from "../../shared/constants";
import { toast } from "react-toastify";


class PengaturanMaintenance extends Component {
  constructor() {
    super();
    this.state = {
      is_maintenance: '',
      loading: false,
      baseUrl: process.env.REACT_APP_DOMAIN_API
    }
  }

  componentDidMount() {
    const auth = getUser()
    console.log(auth.token)
    Axios.get(`${URL_API}api/apps`,
      { headers: { "Authorization": `Bearer ${auth.token}` } }
    ).then(res => {
      console.log(res)
      if (res.status === 200) {
        this.setState({ loading: false })
        res.data.data.forEach(element => {
          if (element.name == 'is_maintenance') {
            this.setState({ is_maintenance: element.value })
          }
        });
      }
    })
  }

  handleSubmit = () => {
    const { is_maintenance } = this.state
    this.setState({ loading: true })
    const formData = new FormData();
    formData.append('is_maintenance', is_maintenance);
    const auth = getUser()
    const post = Axios.post(`${URL_API}api/apps`, formData,
      { headers: { "Content-type": `multipart/form-data;boundary=${formData._boundary}`, "Authorization": `Bearer ${auth.token}` } }
    ).then(res => {
      if (res.status === 200) {
        this.setState({ loading: false })

        toast.success('Berhasil mengganti pengaturan maintenance')
      }
    })
  }

  handleChange(val) {

    if (!val.target.value) {
      toast.warning('Harap isi pengaturan maintenance')
    }

    this.setState({ is_maintenance: val.target.value })
  }

  render() {
    const { loading, is_maintenance } = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <h5 className="modal-title mt-0">Pengaturan Maintenance</h5>
                <form className="form-horizontal mt-4">
                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Maintenance *</label>
                    <div className="col-sm-4">
                      <SelectForm
                        name="is_maintenance"
                        required
                        type="select"
                        value={is_maintenance}
                        className="form-control"
                        onChange={(val) => this.handleChange(val)}
                      >
                        <option value=''>Pilih</option>
                        <option value="Ya">
                          Ya
                        </option>
                        <option value="Tidak">
                          Tidak
                        </option>
                      </SelectForm>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label"></label>
                    <div className="col-sm-4">
                      <button
                        disabled={is_maintenance ? false : true}
                        type="button"
                        className="btn btn-primary"
                        onClick={() => this.handleSubmit()}
                      >
                        {loading ? <Spinner size="sm" color="light" /> : 'Simpan'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment >
    )
  }
}


export default PengaturanMaintenance;